import { OPEN_DURATION_FILTER } from "app/components/duration-selector/durationFilterActionTypes";
import {
    CLOSE_COUNTRY_FILTER,
    OPEN_COUNTRY_FILTER,
} from "app/components/filters-bar/country-filter/countryFilterActionTypes";
import type { IPeriodOverPeriodCompareType } from "app/services/periodOverPeriodTypes";
import type { ThunkDispatchCommon } from "single-spa/store/types";

export const showDurationFilterHof =
    (dispatch: FixmeType) => (periodOverPeriodCompareType?: IPeriodOverPeriodCompareType) => {
        dispatch({ type: OPEN_DURATION_FILTER, periodOverPeriodCompareType });
    };

export const showCountryFilterHof = (dispatch: ThunkDispatchCommon) => () => {
    dispatch({ type: OPEN_COUNTRY_FILTER });
};

export const hideCountryFilterHof = (dispatch: ThunkDispatchCommon) => () => {
    dispatch({ type: CLOSE_COUNTRY_FILTER });
};
